var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHoliday(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14829_10238)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14829_10238",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 5,
    width: 39,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.1772 5.71143H0.177246V30.7114H38.1772V5.71143Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14829_10238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7676 15.2554L10.4454 18.3284L4.27458 15.5036C4.08226 15.3944 3.86653 15.3316 3.64496 15.3203C3.42339 15.3089 3.20224 15.3494 2.99951 15.4384L1.01743 16.3523C0.79802 16.442 0.606124 16.5866 0.460738 16.7719C0.315352 16.9572 0.221517 17.1767 0.188521 17.4088C0.155525 17.6409 0.184512 17.8775 0.272613 18.0951C0.360713 18.3128 0.504873 18.5039 0.690824 18.6497L7.99895 24.1938C8.3495 24.4856 8.7802 24.6678 9.23609 24.717C9.69198 24.7662 10.1524 24.6803 10.5586 24.4702L18.3844 20.6927V29.3928C18.3893 29.6427 18.4633 29.8866 18.5983 30.098C18.7334 30.3095 18.9244 30.4805 19.1508 30.5926C19.3499 30.6792 19.5668 30.7189 19.7842 30.7086C20.0015 30.6984 20.2135 30.6384 20.4034 30.5335L23.5071 29.202C23.6961 29.1093 23.8604 28.9741 23.9869 28.8073C24.1134 28.6405 24.1985 28.4468 24.2354 28.2416L26.3642 17.1419L34.6673 12.2685C36.9194 10.8901 38.0314 9.69912 38.1653 8.52086C38.1801 7.91791 37.9881 7.32771 37.6204 6.84598C37.2527 6.36424 36.7309 6.01923 36.1396 5.86687C35.1412 5.6258 33.009 5.46214 29.9211 7.08328L22.6942 11.26",
    fill: "#1BDB9B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7228 11.0968L13.4332 7.00022C13.2443 6.9128 13.039 6.86529 12.8304 6.86072C12.6218 6.85615 12.4146 6.89462 12.222 6.97368L9.44606 7.91363C9.19473 8.00897 8.97454 8.17022 8.80923 8.37998C8.64393 8.58974 8.53977 8.84006 8.50801 9.10395C8.47624 9.36784 8.51807 9.63527 8.62898 9.87742C8.73989 10.1196 8.91568 10.3272 9.13738 10.478L15.2304 15.4244",
    fill: "#17AA9F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14829_10238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 25,
    fill: "white",
    transform: "translate(0.177246 5.71143)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHoliday);
export default __webpack_public_path__ + "static/media/icon_holiday.ba234f0d4cca34385b161325521d28b8.svg";
export { ForwardRef as ReactComponent };